import EA from '../helpers/init';
import Api from '../helpers/axios';

export default EA.Methods.newsletterSubscribe = ($this) => {
    const form = $this;
    const emailInput = form.querySelector('input[name="email"]');
    const consentInput = form.querySelector('input[name="consent"]');
    const websiteInput = form.querySelector('input[name="website"]');
    const message = form.querySelector('.footer-newsletter-message');
    const submit = form.querySelector('button[type="submit"]');

    form.addEventListener('submit', async (event) => {
        event.preventDefault();

        if(message) {
            message.textContent = '';
        }

        if(!emailInput?.value || !consentInput?.checked) {
            form.reportValidity();
            return;
        }

        if(submit) {
            submit.disabled = true;
        }

        try {
            const response = await Api.post('/newsletter', {
                email: emailInput.value,
                consent: consentInput.checked,
                website: websiteInput?.value || '',
            });

            if(message) {
                message.textContent = response.data?.message || 'Hvala na prijavi.';
            }

            form.reset();
        } catch (error) {
            if(message) {
                message.textContent = error.response?.data?.message || 'Prijava nije uspjela. Pokušajte ponovno.';
            }
        } finally {
            if(submit) {
                submit.disabled = false;
            }
        }
    });
};
